export default __webpack_public_path__ + "static/media/image6.84c7d069.jpg";